import { getApiEndpoint } from './config.js';
import { checkLogin, checkToken } from './account.js';

/**
 * Get auto replies.
 *
 * @param {object} token - The token to use, for getting conversations.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * conversations.
 */
export function getAutoReplies(token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/auto-replies', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}

/**
 * Save the message for an auto reply.
 *
 * @param {int} autoReplyId - The id of the auto reply.
 * @param {string} message - The message to save.
 * @param {object} token - The token to use, for getting conversation.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * conversation.
 */
export function saveAutoReplyMessage(autoReplyId, message, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/auto-replies/' + autoReplyId, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
    body: JSON.stringify([{
      op: 'set',
      fields: {
        message: message,
      },
    }]),
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}



// WEBPACK FOOTER //
// ./src/utility/autoReply.js